import React, { useContext } from 'react';
import { IconButton, Box } from '@mui/material';

import { updateAction } from '../action/updateAction';
import { RecordContext } from '../record-context';

import { uid } from '../../utils';
import addIcon from '../../images/icons/plus.svg';

import { useStyles } from './styles';
import useAnalytics from "../../segment/useAnalytics";

export const StepSeparator = ({ index, isHide }) => {
  const classes = useStyles({isHide});
  const {record, recordDispatch} = useContext(RecordContext);
  const { captureStepAdded } = useAnalytics();

  const handleAddStep = () => {
    const arr = record.arr;
    const stepId = uid();
    arr.splice(index, 0, {name: `Step ${index + 1}`, id: stepId});
    recordDispatch(updateAction({
      ...record,
      arr,
      needSave: true
    }))
    captureStepAdded({ stepId: stepId });
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.line}/>
      <Box>
        <IconButton aria-label="add" onClick={handleAddStep}>
          <img src={addIcon} alt="add"/>
        </IconButton>
      </Box>
      <Box className={classes.line}/>
    </Box>
  )
}